import { render, staticRenderFns } from "./ChristmasDecoration.vue?vue&type=template&id=3e7506ba&scoped=true&"
import script from "./ChristmasDecoration.vue?vue&type=script&lang=js&"
export * from "./ChristmasDecoration.vue?vue&type=script&lang=js&"
import style0 from "./ChristmasDecoration.vue?vue&type=style&index=0&id=3e7506ba&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e7506ba",
  null
  
)

export default component.exports